import { observer } from 'mobx-react-lite';

import { Breadcrumb } from '@components/breadcrumb';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Header } from 'components/headers';
import { Loading } from 'components/Loading';
import { PageContent } from 'components/Page';
import { useJobBoards } from 'jobboards/useJobBoards';
import { useStore } from 'models/Provider';

import { ActiveJobBoards } from './ActiveJobBoards';
import { AvailableJobBoards } from './AvailableJobBoards';

export const JobBoards = observer(() => {
  const { status, availableBoards, activeBoards, activate, deactivate } = useJobBoards();
  const { t } = useStore();

  if (status === 'loading') {
    return <Loading delay={1000} />;
  }

  return (
    <>
      <Header
        breadcrumbs={<Breadcrumb items={[{ label: t('company.settings.jobboards.header') }]} />}
      />
      <PageContent>
        <Stack space={6}>
          <Stack space={2}>
            <Text font="bold18" text={t('company.settings.jobboards.header')} />
            <Text
              font="regular14"
              color="textSecondary"
              text={t('company.settings.jobboards.subtitle')}
            />
          </Stack>
          <Separator />
          <Stack space={8}>
            <ActiveJobBoards boards={activeBoards} deactivate={deactivate} />
            {availableBoards.length > 0 && (
              <AvailableJobBoards boards={availableBoards} activate={activate} />
            )}
          </Stack>
        </Stack>
      </PageContent>
    </>
  );
});
